module.exports = __webpack_public_path__ + "img/num2.148a5b3a.png";